import { z } from 'zod';

const MAX_LENGTH = 512;
const TOO_LONG = `Must be at most ${MAX_LENGTH} characters long`;
const INVALID = 'Should be a valid email';

/**
 * An email address, lowercased and trimmed while parsing so what is stored and
 * compared is canonical.
 *
 * @param requiredMessage reported when the value is missing or empty; omit for
 * an optional email (add `.optional()` at the field)
 */
export const emailValidation = (requiredMessage?: string) => {
  const email = z
    .string(requiredMessage)
    .trim()
    .toLowerCase()
    .max(MAX_LENGTH, TOO_LONG)
    .check(z.email(INVALID));

  return requiredMessage ? email.min(1, requiredMessage) : email;
};
